export default "__VITE_ASSET__1c632e2a__"